var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusCounterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FEF0F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.64 13.436V11.42H8.44V13.436H15.64Z",
    fill: "#F73B58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCounterIcon);
export default __webpack_public_path__ + "static/media/minus-counter-icon.ce9f173483be8e390dc4ca98429993d1.svg";
export { ForwardRef as ReactComponent };